import type { CheckoutSession } from "@/react/types/Paywalls/Checkout/Session";
import { checkoutSessionStatuses } from "@/react/types/Paywalls/Checkout/Session";

export const isSessionCompleted = (session: CheckoutSession): boolean =>
  session.status === checkoutSessionStatuses.completed;

export const isSessionPending = (session: CheckoutSession): boolean =>
  session.status === checkoutSessionStatuses.pending;

export const isSessionAbandoned = (session: CheckoutSession): boolean =>
  session.status === checkoutSessionStatuses.abandoned;
